import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=57d11df0&scoped=true&"
import script from "./CardComponent.vue?vue&type=script&lang=ts&"
export * from "./CardComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=57d11df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d11df0",
  null
  
)

export default component.exports